import { render, staticRenderFns } from "./relatedCategories.vue?vue&type=template&id=8a99cfaa&scoped=true&"
import script from "./relatedCategories.vue?vue&type=script&lang=js&"
export * from "./relatedCategories.vue?vue&type=script&lang=js&"
import style0 from "./relatedCategories.vue?vue&type=style&index=0&id=8a99cfaa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99cfaa",
  null
  
)

export default component.exports